import { Box } from "arkh";
import React from "react";

export function FileRowWrapper(props: {
  icon: React.ReactNode | null;
  title: React.ReactNode;
  size: React.ReactNode;
  detail: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box style={{ width: "50%", flexDirection: "row", alignItems: "center" }}>
        {props.icon ? <Box spaceRight="small">{props.icon}</Box> : null}
        <Box style={{ flex: 1 }} spaceRight="small">
          {props.title}
        </Box>
      </Box>
      <Box style={{ width: "20%" }}>{props.size}</Box>
      <Box style={{ width: "20%" }}>{props.detail}</Box>
      {props.action ? (
        <Box
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            justifyContent: "center",
          }}
        >
          {props.action}
        </Box>
      ) : null}
    </Box>
  );
}
